import { css } from "@emotion/react";
import colors from "../../styles/colors";
export function getTheme(variant, family, bold, italic, color) {
    let styleCss;
    const Bold = bold ? 600 : 400;
    let textcolor;
    if (color) {
        textcolor = colors[color];
    }
    switch (variant) {
        case "heading55":
            styleCss = {
                fontSize: 3.438,
                lineHeight: 4.297,
                bold: 700,
            };
            break;
        case "heading40":
            styleCss = {
                fontSize: 2.5,
                lineHeight: 3.125,
                bold: 600,
            };
            break;
        case "heading32":
            styleCss = {
                fontSize: 2,
                lineHeight: 2.5,
                bold: 700,
            };
            break;
        case "heading24":
            styleCss = {
                fontSize: 1.5,
                lineHeight: 1.875,
                bold: 700,
            };
            break;
        case "heading22":
            styleCss = {
                fontSize: 1.375,
                lineHeight: 1.71875,
                bold: 700,
            };
            break;
        case "heading20":
            styleCss = {
                fontSize: 1.25,
                lineHeight: 1.74,
                bold: 700,
            };
            break;
        case "heading18":
            styleCss = {
                fontSize: 1.125,
                lineHeight: 1.75,
                bold: bold ? 600 : 500,
            };
            break;
        case "heading16":
            styleCss = {
                fontSize: 1,
                lineHeight: 1.5,
                bold: Bold,
            };
            break;
        case "heading14":
            styleCss = {
                fontSize: 0.875,
                lineHeight: 1.313,
                bold: 600,
            };
            break;
        case "paragraph18":
            styleCss = {
                fontSize: 1.125,
                lineHeight: 1.75,
                bold: Bold,
            };
            break;
        case "paragraph14":
            styleCss = {
                fontSize: 0.875,
                lineHeight: 1.313,
                bold: Bold,
            };
            break;
        case "paragraph12":
            styleCss = {
                fontSize: 0.75,
                lineHeight: 1.125,
                bold: Bold,
            };
            break;
        case "paragraph10":
            styleCss = {
                fontSize: 0.625,
                lineHeight: 1,
                bold: bold ? 600 : 500,
            };
            break;
        case "paragraph9":
        default:
            styleCss = {
                fontSize: 0.563,
                lineHeight: 0.703,
                bold: 500,
            };
            break;
    }
    return css `
    font-family: ${family ? family : "Inter"};
    font-size: ${styleCss.fontSize}rem;
    line-height: ${styleCss.lineHeight}rem;
    font-weight: ${styleCss.bold};
    font-style: ${italic ? "italic" : "normal"};
    color: ${textcolor};
  `;
}
//# sourceMappingURL=themes.js.map